export default __webpack_public_path__ + "static/media/lastcolony.92819788.png";